<script lang="ts">
  export let size: 'small' | 'medium' | 'large'
  const fill: string = 'currentColor'
</script>

<svg class="svg-{size}" {fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 8C2 5.79086 3.79086 4 6 4H26C28.2091 4 30 5.79086 30 8V11C30 11.5523 29.5523 12 29 12H28V26C28 28.2091 26.2091 30 24 30H8C5.79086 30 4 28.2091 4 26V12H3C2.44772 12 2 11.5523 2 11V8ZM4 10H28V8C28 6.89543 27.1046 6 26 6H6C4.89543 6 4 6.89543 4 8V10ZM6 12V26C6 27.1046 6.89543 28 8 28H24C25.1046 28 26 27.1046 26 26V12H6ZM10 16C10 15.4477 10.4477 15 11 15H21C21.5523 15 22 15.4477 22 16V17C22 19.2091 20.2091 21 18 21H14C11.7909 21 10 19.2091 10 17V16ZM12 17C12 18.1046 12.8954 19 14 19H18C19.1046 19 20 18.1046 20 17H12Z"
  />
</svg>
